import StoryTampa from './StoryTampa';
// import RowButtonTampa from './RowButtonTampa';
// import NavButtonTampa from './NavButtonTampa';
import BackButtonTampa from './BackButtonTampa';
import ScrollSpacer from '../Miami/ScrollSpacer';
import React, { Component } from 'react';
import ReactIScroll from 'react-iscroll';
import iScroll from 'iscroll';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
// import Moment from 'react-moment';
import _ from 'lodash';
import { dp, presetDp } from '../../../utils/shared.js';
import InfoBlockTampa from './InfoBlockTampa';

// const QuillDeltaToHtmlConverter = require('quill-delta-to-html');

class StoriesTampa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      story: null,
      showModal: false,
      iScrollInitialized: false
    };

    this.storyRefs = {};
  }

  componentWillUnmount() {
    for (let id in this.storyRefs) {
      this.storyRefs[id].removeEventListener("tap", () => this.handleTap(id));
    }
    clearTimeout(this._modalTimeout);
    this._modalTimeout = null;
  }

  initializeIScroll = () => {
    if (this.state.iScrollInitialized === false) {
      for (let id in this.storyRefs) {
        this.storyRefs[id].addEventListener("tap", () => this.handleTap(id));
      }

      this.setState({
        iScrollInitialized: true
      });
    }
  }

  handleTap = (id) => {
    let story = this.props.module.children.find(st => st.folder_module_id === Number(id));

    if (this.state.showModal) {
      this.setState({
        showModal: false
      });

      clearTimeout(this._modalTimeout);
      this._modalTimeout = null;
      this._modalTimeout = setTimeout(() => {
        this.setState({
          story: story,
          showModal: true
        });
      }, 500);
    } else {
      this.setState({
        story: story,
        showModal: true
      });
    }
  }

  handleBack = () => {
    this.props.showNavButton(true);
    this.setState({
      showModal: false
    })
  }

  renderStories = () => {
    let storySets = [];
    let setCount = 0;
    let stories = _.sortBy(this.props.module.children, (s) => {
      return s.sorting_name.toLowerCase();
    });
    for (var i = 0; i < stories.length; i++) {
      if (!storySets[setCount]) {
        storySets[setCount] = [];
      }
      storySets[setCount].push(stories[i]);
      if (stories.length - 1 === i && storySets[setCount].length === 1) {
        storySets[setCount].push(null);
      }
      if ((i + 1) % 2 === 0 && i !== 0) {
        setCount++
      }
    }
    return (
      storySets.map((row, i) => {
        return (
          <div key={i} style={{ marginBottom: this.props.screen.screenHeight * .01953125, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-around' }}>
            {this.renderRow(row, i)}
          </div>
        )
      })
    );
  }

  renderRow = (row) => {
    if (row.length === 0) {
      return null;
    }
    return (
      row.map((innerrow, i) => {
        if (innerrow === null) {
          return (<div key={i} style={{ display:"inline-block" }}><div style={{ width:"15vh" }}></div></div>);
        }
        return (
          <div key={i} style={{ display: 'inline-block' }}>
            {this.renderStory(innerrow, i)}
          </div>
        )
      })
    )
  }

  renderStory = (row, i) => {
    const unit = this.props.screen.r9_16.p10 / this.props.screensNumber;
    let backgroundObj = _.get(this.props.menu, 'contents.images[0]', null);
    let backgroundImage =  presetDp(null, backgroundObj, this.props.screen);
    let mult = .8
    return (
      <div ref={el => this.storyRefs[row.folder_module_id] = el} style={{ marginRight: unit * .175, display: 'inline-block' }}>
        <InfoBlockTampa
          imgsrc={dp(this.props.screen, _.get(row, 'contents.images[0]', null), { path: '/img/ui/', file_name: 'image_default.png' })}
          imageHeight={unit * 2 * mult}
          infoHeight={"4.6875vh"}
          width={"15vh"}
          unit={unit * mult}
          text={row.name}
          infoColor={"black"}
          infoBackgroundColor={'white'}
          backgroundImage={backgroundImage}
          fontFamily={'opensans-regular'}
          fontSize={unit * 0.15}
        />
      </div>
    )
  }

  renderBackButton = () => {
    return (
      <BackButtonTampa
        unit={this.props.screen.r9_16.p10 / this.props.screensNumber}
        width="3.90625vh"
        height="4.5vh"
        top="56.46875vh"
        border="0.84375vh"
        clickAction={this.handleBack}
        text={'back'}
        mode={this._mode}>
      </BackButtonTampa>
    );
  }

  getBackgroundImage = () => {
    let defaultImg = { path: '/img/miami/general/', file_name: 'default_single_screen.jpg' }

    if (this.props.screensNumber === 2) {
      defaultImg.file_name = 'default_double_screen.jpg';
    }

    try {
      let backgroundObj = _.get(this.props.module, 'contents.images[0]', null);
      return dp(this.props.screen, backgroundObj, defaultImg);
    } catch (e) {
      return dp(this.props.screen, defaultImg);
    }
  }

  getIconImage = () => {
    let iconObj = _.get(this.props.module, 'contents.images[2]', null);
    return dp(this.props.screen, iconObj, null);
  }

  getModalContent = () => {
    let menuFolder = this.props.content.story_categories.find(folder => {
      let folderType = _.get(folder, 'contents.custom_fields.folder_type.val.value', null);
      if (folderType !== null) {
        return folder.parent_category === Number(this.props.content.settings.selected_root_folder) && folderType === "menu"
      }

      return false;
    });
    let backgroundObj = _.get(menuFolder.contents, 'images[0]', null);
    let backgroundImage = dp(this.props.screen, backgroundObj);
    let showBackground = true;
    return (
      <StoryTampa 
        backgroundImage={backgroundImage}
        showBackground={showBackground}
        screen={this.props.screen}
        screensNumber={this.props.screensNumber}
        navRoute={this.props.navRoute}
        story={this.state.story}
        background={this.getBackgroundImage()}
        mode={this._mode}
        clickAction={this.handleBack}
        contentIndex={this.state.contentIndex}
      />
    );
  }

  getSubscribeModule = () => {
    this._menuModules = _.filter(this.props.content.dm_active, { module_contents: { in_navigation: true } });
    let type = "";
    this._menuModules.forEach((module, row) => {
      if (module.display_module_type === "User Input") {
        if (_.has(module, 'contents.custom_fields.user_input_type.val')) {
          type = module.contents.custom_fields.user_input_type.val;

          if (type === "subscribe") {
            this._subscribeModule = module;
            return;
          }
        }
      }
    });
  }

  redirect = () => {
    if (this._subscribeModule !== null && this._subscribeModule !== undefined) {
      this.props.navRoute('/miami/subscribe', this._subscribeModule);
    }
  }

  render() {
    const unit = this.props.screen.r9_16.p10;
    const backgroundImage = this.getBackgroundImage();
    const iconImage = this.getIconImage();
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;

    const textShadowSize = Math.ceil(this.props.screen.screenHeight * 0.003);
    const textShadow = `${textShadowSize}px ${textShadowSize}px ${textShadowSize}px black`;

    // let headerOps = _.get(this.props.module, 'contents.custom_fields.title.val.ops', _.get(this.props.module, 'contents.custom_fields.title.default.ops', null));
    // let headerRichText = new QuillDeltaToHtmlConverter(headerOps, {}).convert();

    // let bodyOps = _.get(this.props.module, 'contents.custom_fields.body.val.ops', _.get(this.props.module, 'contents.custom_fields.body.default.ops', null));
    // let bodyRichText = new QuillDeltaToHtmlConverter(bodyOps, {}).convert();

    let modalStyle = {
      position: "absolute",
      width: this.props.screen.screenWidth / this.props.screensNumber,
      left: this.props.screensNumber === 1 ? 0 : this.props.screen.screenWidth / this.props.screensNumber
    }

    return (
      <div style={{ width: this.props.screen.screenWidth, height: this.props.screen.r9_16.height, backgroundImage: "url(" + backgroundImage + ")", backgroundSize: backgroundSize }} >
        <div style={{ position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber }} >
          <div>
            <div style={{ position: "absolute", width: this.props.screen.screenWidth / this.props.screensNumber }} >
              <div style={{ display: "block", marginLeft: "auto", textAlign: "center", marginRight: "auto", width: '100%' }}>
                <div style={{ height: "2.5vh" }}>
                </div>
                <img  role="presentation" src={iconImage} style={{ width: '14vh' }} />
              </div>
              <div className="crimson-semi-bold" style={{ textShadow: textShadow,textAlign: "center", fontSize: '4vh' }}>
                <span>{this.props.module.name}</span>
              </div>
              <div className="crimson-regular" style={{ textShadow: textShadow,fontSize: '2vh', textAlign: "center", paddingRight: "7vh", paddingLeft: "7vh", lineHeight: this.props.screen.screenWidth * .03240740740740740741 + "px" }}>
                {this.props.module.description}
              </div>
              <div style={{ height: '8.6vh' }} />
              <div className="topgradblackP25" style={{ position: "absolute", width: '100%', height: "2.8125vh", top: "26.979166667vh" }} />
              <div style={{ display:"flex", justifyContent: "center" }}>
                <div style={{ color: 'black', width: '85%', height: "73.0468vh", display: "block", marginLeft: "auto", marginRight: "auto", marginTop: "-1.6875vh", touchAction: "none", position: "absolute", top: "28.7760vh" }}>
                  <ReactIScroll ref={el => this.iScroller = el} iScroll={iScroll}
                    options={{
                      mouseWheel: true,
                      scrollbars: false,
                      scrollX: false,
                      scrollY: true,
                      probeType: 2,
                      bounce: false,
                      momentum: true,
                      deceleration: 0.005,
                      useTransition: true,
                      disableTouch: false,
                      disablePointer: false,
                      disableMouse: false,
                      tap: true
                    }}
                    onRefresh={this.initializeIScroll}
                  >
                    <div>
                      <div style={{ height: "3.5vh" }}></div>
                      {
                        this.renderStories()
                      }
                      <ScrollSpacer unit={unit} />
                    </div>
                  </ReactIScroll>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{ ...modalStyle }}>
          <CSSTransitionGroup
            component='div'
            className="containerFade"
            style={{ minHeight: '100%' }}
            transitionName='example'
            transitionEnterTimeout={0}
            transitionLeaveTimeout={0}>
            <div key={this.state.showModal}>
              {this.state.showModal ? this.getModalContent() : null}
              {this.state.showModal ? this.renderBackButton() : null}
            </div>
          </CSSTransitionGroup >
        </div>
      </div>

    )
  }
}

export default StoriesTampa;


// WEBPACK FOOTER //
// ./src/Components/Theme/Tampa/StoriesTampa.jsx